















import Vue from 'vue';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Helpers from './helpers';

export default Vue.extend({
  name: 'App',
  components: {
    Header, Footer
  }
});

// Preload heavy assets used in other pages
Helpers.preloadAssets([
    // "img/projects/Doodis/Cover.mp4",
    // "img/projects/AlienAnnihilationVE/Cover.mp4",
]);


